module.exports = __webpack_public_path__ + "static/img/bg.6e5ff76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listen-report2023/bg.png
// module id = Bf5p
// module chunks = 215